export default __webpack_public_path__ + "static/media/weth.32818c6c.svg";